"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = _default;

var _react = _interopRequireDefault(require("react"));

var _lodash = _interopRequireDefault(require("lodash.mapvalues"));

var _slateIconShared = require("@canner/slate-icon-shared");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _default(Tag, markType) {
  var stylesAttr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _slateIconShared.markAttrs;
  return {
    deserialize: function deserialize(el, next) {
      if (markType && el.tagName && el.tagName.toLowerCase() === Tag) {
        var data = {};

        if (el.style.backgroundColor) {
          data.color = el.style.backgroundColor;
        }

        if (el.style.color) {
          data.color = el.style.color;
        }

        if (el.style.fontSize) {
          data.fontSize = el.style.fontSize;
        }

        if (el.style.letterSpacing) {
          data.letterSpacing = el.style.letterSpacing;
        }

        return {
          object: "mark",
          type: markType,
          data: data,
          nodes: next(el.childNodes)
        };
      }
    },
    serialize: function serialize(obj, children) {
      if (obj.object == "mark" && obj.type === markType) {
        return _react.default.createElement(Tag, {
          style: (0, _lodash.default)(stylesAttr, function (val) {
            return val && val(obj);
          })
        }, children);
      }
    }
  };
}